import { render } from "./HeadBlock.vue?vue&type=template&id=c08e25ec"
import script from "./HeadBlock.vue?vue&type=script&lang=js"
export * from "./HeadBlock.vue?vue&type=script&lang=js"

import "./HeadBlock.vue?vue&type=style&index=0&id=c08e25ec&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__